import Card from '@/components/Common/Card';

export default {
  name: 'ComplainsCTA',
  
  components: { Card },

};



// WEBPACK FOOTER //
// ./src/components/Complains/ComplainsCTA/component.js